"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; } var _class;

var _chunkAZDNTOBWcjs = require('./chunk-AZDNTOBW.cjs');


var _chunkIIMQROIVcjs = require('./chunk-IIMQROIV.cjs');


var _chunkNE5AG7IWcjs = require('./chunk-NE5AG7IW.cjs');

// src/contracts/dex/v1/LpAccountV1.ts



var _ton = require('@ton/ton');
var LpAccountV1 = (_class = class _LpAccountV1 extends _chunkIIMQROIVcjs.Contract {
  static __initStatic() {this.version = _chunkNE5AG7IWcjs.DEX_VERSION.v1}
  static __initStatic2() {this.gasConstants = {
    refund: _ton.toNano.call(void 0, "0.3"),
    directAddLp: _ton.toNano.call(void 0, "0.3"),
    resetGas: _ton.toNano.call(void 0, "0.3")
  }}
  
  constructor(address, { gasConstants, ...options } = {}) {
    super(address, options);
    this.gasConstants = {
      ..._LpAccountV1.gasConstants,
      ...gasConstants
    };
  }
  async createRefundBody(params) {
    return _ton.beginCell.call(void 0, ).storeUint(_chunkAZDNTOBWcjs.DEX_OP_CODES.REFUND_ME, 32).storeUint(_nullishCoalesce(_optionalChain([params, 'optionalAccess', _ => _.queryId]), () => ( 0)), 64).endCell();
  }
  /**
   * Build all data required to execute a `refund_me` transaction.
   *
   * @param {bigint | number | string | undefined} params.gasAmount - Optional; Custom transaction gas amount (in nanoTons)
   * @param {bigint | number | undefined} params.queryId - Optional; query id
   *
   * @returns {SenderArguments} all data required to execute a `refund_me` transaction.
   */
  async getRefundTxParams(provider, params) {
    const to = this.address;
    const body = await this.createRefundBody({
      queryId: _optionalChain([params, 'optionalAccess', _2 => _2.queryId])
    });
    const value = BigInt(_nullishCoalesce(_optionalChain([params, 'optionalAccess', _3 => _3.gasAmount]), () => ( this.gasConstants.refund)));
    return { to, value, body };
  }
  async sendRefund(provider, via, params) {
    const txParams = await this.getRefundTxParams(provider, params);
    return via.send(txParams);
  }
  async createDirectAddLiquidityBody(params) {
    return _ton.beginCell.call(void 0, ).storeUint(_chunkAZDNTOBWcjs.DEX_OP_CODES.DIRECT_ADD_LIQUIDITY, 32).storeUint(_nullishCoalesce(_optionalChain([params, 'optionalAccess', _4 => _4.queryId]), () => ( 0)), 64).storeCoins(BigInt(params.amount0)).storeCoins(BigInt(params.amount1)).storeCoins(BigInt(_nullishCoalesce(params.minimumLpToMint, () => ( 1)))).endCell();
  }
  /**
   * Build all data required to execute a `direct_add_liquidity` transaction.
   *
   * @param {bigint | number} params.amount0 - Amount of the first Jetton tokens (in basic token units)
   * @param {bigint | number} params.amount1 - Amount of the second Jetton tokens (in basic token units)
   * @param {bigint | number | undefined} params.minimumLpToMint - Optional; minimum amount of received liquidity tokens (in basic token units)
   * @param {bigint | number | string | undefined} params.gasAmount - Optional; Custom transaction gas amount (in nanoTons)
   * @param {bigint | number | undefined} params.queryId - Optional; query id
   *
   * @returns {SenderArguments} all data required to execute a `direct_add_liquidity` transaction.
   */
  async getDirectAddLiquidityTxParams(provider, params) {
    const to = this.address;
    const body = await this.createDirectAddLiquidityBody({
      amount0: params.amount0,
      amount1: params.amount1,
      minimumLpToMint: params.minimumLpToMint,
      queryId: params.queryId
    });
    const value = BigInt(_nullishCoalesce(params.gasAmount, () => ( this.gasConstants.directAddLp)));
    return { to, value, body };
  }
  async sendDirectAddLiquidity(provider, via, params) {
    const txParams = await this.getDirectAddLiquidityTxParams(provider, params);
    return via.send(txParams);
  }
  async createResetGasBody(params) {
    return _ton.beginCell.call(void 0, ).storeUint(_chunkAZDNTOBWcjs.DEX_OP_CODES.RESET_GAS, 32).storeUint(_nullishCoalesce(_optionalChain([params, 'optionalAccess', _5 => _5.queryId]), () => ( 0)), 64).endCell();
  }
  /**
   * Build all data required to execute a `reset_gas` transaction.
   *
   * @param {bigint | number | string | undefined} params.gasAmount - Optional; Custom transaction gas amount (in nanoTons)
   * @param {bigint | number | undefined} params.queryId - Optional; query id
   *
   * @returns {SenderArguments} all data required to execute a `reset_gas` transaction.
   */
  async getResetGasTxParams(provider, params) {
    const to = this.address;
    const body = await this.createResetGasBody({
      queryId: _optionalChain([params, 'optionalAccess', _6 => _6.queryId])
    });
    const value = BigInt(_nullishCoalesce(_optionalChain([params, 'optionalAccess', _7 => _7.gasAmount]), () => ( this.gasConstants.resetGas)));
    return { to, value, body };
  }
  async sendResetGas(provider, via, params) {
    const txParams = await this.getResetGasTxParams(provider, params);
    return via.send(txParams);
  }
  /**
   * @returns structure containing current state of the lp account.
   */
  async getLpAccountData(provider) {
    const result = await provider.get("get_lp_account_data", []);
    return {
      userAddress: result.stack.readAddress(),
      poolAddress: result.stack.readAddress(),
      amount0: result.stack.readBigNumber(),
      amount1: result.stack.readBigNumber()
    };
  }
}, _class.__initStatic(), _class.__initStatic2(), _class);



exports.LpAccountV1 = LpAccountV1;
//# sourceMappingURL=chunk-ZNXISNXV.cjs.map